<template>
  <div class="form-horizontal form-material">
    <form class="form-horizontal" method="post" @submit.prevent="doResetPassword">
      <div class="form-group ">
        <div class="col-xs-12">
          <h3>Reset Password</h3>
          <alert-box type="danger" v-if="error && error.message">
            {{ error.message }}
          </alert-box>
          <p class="text-muted">Enter the new password in the both fields! </p>
        </div>
      </div>
      <input-text
        type="password"
        name="password"
        :value="form.password"
        class="col-xs-12"
        placeholder="Password"
        @input="text => { setField({ key: 'password', value: text }) }"
      />

      <input-text
        type="password"
        name="rePassword"
        :value="form.rePassword"
        class="col-xs-12"
        placeholder="RePassword"
        @input="text => { setField({ key: 'rePassword', value: text }) }"
      />
      <div class="form-group text-center m-t-20">
        <div class="col-xs-12">
          <form-button
            type="primary"
            inputType="submit"
            text="Reset"
            :loading="loading"
            :block="true"
            :click="() => {}"
            class="btn btn-lg btn-block btn-rounded"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InputText from '@/components/Form/InputText';
  import FormButton from '@/components/Form/FormButton';
  import AlertBox from '@/components/Misc/AlertBox';

  export default {
    name: "newPasswordSetting",
    components: {
      InputText,
      FormButton,
      AlertBox,
    },
    beforeMount() {
      const query = this.$route.query;
      const token = query.token;
      // this.setField({ key: 'resetToken', value: token })
      
      // this.forgotPwdCheckToken(token);
    },
    computed: {
      ...mapGetters({
        form: 'auth/form',
        loading: 'auth/loading',
        tokenValid: 'auth/tokenValid',
        error: 'auth/error',
      }),
    },
    methods: {
      ...mapActions({
        setField: 'auth/setField',
        // forgotPwdCheckToken: 'auth/forgotPwdCheckToken',
        resetPassword: 'auth/resetPassword',
      }),

      async doResetPassword() {
        await this.resetPassword({'password': this.form.password, 'repassword': this.form.rePassword, 'resetToken': this.$route.query.token});
      },
    },
  };
</script>
